import ConfigNode from './ConfigNode'
import { graph } from './constants'

class ConfigList extends ConfigNode

  constructor: (nodeId) ->
    super(nodeId)

  list: ->
    @get('value')
      .split('#!#')
      .filter((index) -> index isnt '')

  update: (keys, params = {}) ->
    @set('value', keys.join('#!#'))
    @save(params)

export default ConfigList
